import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  ModalFooter,
  Button,
  useDisclosure,
  IconButton,
} from '@chakra-ui/react'
import React from 'react'
import { DeleteIcon } from '@chakra-ui/icons'
import { toast } from 'react-toastify'
import { MutationTrigger } from '@reduxjs/toolkit/dist/query/react/buildHooks'

type Props = {
  recordId: number
  mutationFn: MutationTrigger<any>
}

export const DeleteModal = ({ recordId, mutationFn }: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const onConfirm = async () => {
    const toastId = toast.info('Deleting record...', {
      style: { padding: '10px 20px' },
      autoClose: false,
      isLoading: true,
    })
    try {
      await mutationFn({ id: recordId })
      toast.update(toastId, {
        render: `Successfully deleted`,
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      })
    } catch (_error) {
      toast.update(toastId, {
        render: `Failed to delete record!`,
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      })
    }
    onClose()
  }

  return (
    <>
      <IconButton
        aria-label="Delete automation"
        icon={<DeleteIcon />}
        color="icon.strong"
        bg="#F7F9FD"
        rounded="lg"
        variant='unstyled'
        justifyContent="space-around"
        boxSize="32px"
        _hover={{ bg: '#E8EEFD' }}
        onClick={(e) => {
          e.stopPropagation()
          onOpen()
        }}
      />

      <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Text>Are you sure you want to delete this record?</Text>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onConfirm} colorScheme="blue" mr={3}>
              Confirm
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
